import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN, MANUFACTURE } = authRoles

const Receptions = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

const ReceptionsDetail = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/detail.vue')

const ReceptionsReceipts = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/receipts.vue')

export const receptionsModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/receipts',
    name: 'receptions',
    component: Receptions,
    meta: {
      title: 'Recepciones',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
  {
    path: '/receipts/create',
    name: 'receptionsCreate',
    component: ReceptionsDetail,
    meta: {
      title: 'Crear Recepción',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
  {
    path: '/receipts/:id/summary',
    name: 'receptionsDetails',
    component: ReceptionsDetail,
    meta: {
      title: 'Detalles de Recepción',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
  {
    path: '/receipts/:id/apply',
    name: 'receptionsReceipts',
    component: ReceptionsReceipts,
    meta: {
      title: 'Recibir Recepción',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
